<template>
  <div id="content">
    <router-link to="/website">
      <a id="arrow" style="text-align: left"><h2>&larr;</h2> </a>
    </router-link>
    <h1>Conteúdo da Página</h1>
    <span v-if="contents.length == 0">
      <h4 id="no">Não existe conteúdo nesta página</h4></span
    >
    <span v-else>
      <span v-for="content in contents" :key="content.id_content">
        <div class="card w-50">
          <div class="card-body">
            <div class="pt">
              <div class="title">
                <h4 style="color: #f7941e">Titulo: </h4>
                <h4 class="card-title">{{ content.title }}</h4>
              </div>
              <div class="desc">
                <h4 style="color: #f7941e">Descrição: </h4>
                <span class="card-text" v-html="content.description"></span>
              </div>
            </div>
            <div class="en">
              <div class="title">
                <h4 style="color: #f7941e">Titulo (Inglês): </h4>
                <h4 class="card-title">{{ content.title_en }}</h4>
              </div>
              <div class="desc">
                <h4 style="color: #f7941e">Descrição (Inglês): </h4>
                <span class="card-text" v-html="content.description_en"></span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <a
                href="#"
                class="btn btn-primary"
                @click="openModal(content.id_content)"
            >Editar</a
            >
            <a
                href="#"
                class="btn btn-danger"
                @click="delContent(content.id_content)"
            >Remover
            </a>
          </div>
        </div>
      </span>
      <dialog id="editCandidate">
        <form method="dialog">
          <h1>Editar Conteudo</h1>
          <span v-for="info in content" :key="info.id_content">
            <div class="form-group">
              <label for="title">Titulo:</label>
              <input
                type="text"
                class="form-control"
                id="title"
                aria-describedby="emailHelp"
                v-model="title"
              />
            </div>
            <label for="email">Descrição:</label>
            <div class="form-group">
              <vue-editor
                v-model="description"
                :editorOptions="editorSettings"
                :editor-toolbar="customToolbar"
              ></vue-editor>
            </div>
            <div class="form-group">
              <label for="title">Titulo (Inglês):</label>
              <input
                  type="text"
                  class="form-control"
                  id="title"
                  aria-describedby="emailHelp"
                  v-model="titleEn"
              />
            </div>
            <label for="email">Descrição (Inglês):</label>
            <div class="form-group">
              <vue-editor
                  v-model="descriptionEn"
                  :editorOptions="editorSettings"
                  :editor-toolbar="customToolbar"
              ></vue-editor>
            </div>

            <div class="form-group">
              <label for="img">Imagem:</label>
              <input type="text" class="form-control" id="img" v-model="img" />
            </div>
            <button
              style="border:none; background-color: #555555; color:white"
              type="submit"
              @click="editContent(info.id_content)"
            >
              Gravar
            </button>
            <button
              style="border:none; background-color: white"
              @click="closeModal()"
            >
              Fechar
            </button>
          </span>
        </form>
      </dialog>
    </span>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { VueEditor, Quill } from "vue2-editor";
import ImageResize from "quill-image-resize-vue";
Quill.register("modules/imageResize", ImageResize);
export default {
  components: {
    VueEditor,
  },
  data: function() {
    return {
      id: "",
      contents: [],
      content: [],
      title: "",
      description: "",
      titleEn: "",
      descriptionEn: "",
      img: "",
      editorSettings: {
        modules: {
          imageResize: true,
        },
      },
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4] }],
        ["bold", "italic", "underline"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [
          {
            font: [],
          },
        ],
        [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["code-block"],
        ["image"],
      ],
    };
  },
  created() {
    this.getAllContent();
  },
  methods: {
    async getId() {
      this.id = this.$route.params.id;
    },
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.$route.params.id == this.getContent.data[i].page) {
            this.contents.push(this.getContent.data[i]);
          }
        }
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async delContent(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$store.dispatch("deleteContent", { id: id });
          } catch (err) {
            this.$swal({
              title: err.data.status,
              icon: "error",
              confirmButtonText: "Ok!",
            });
          }
          this.getAllContent();
        }
      });
    },
    async editContent(id) {
      this.$swal({
        title: "Tem a certeza que pretende guardar os dados?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Guardar",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$store.dispatch("putContent", {
              id: id,
              title: this.title,
              description: this.description,
              titleEn: this.titleEn,
              descriptionEn: this.descriptionEn,
              img: this.img,
            });
            this.$swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
              icon: "success",
              title: "Candidato eliminado",
            });
          } catch (err) {
            this.$swal({
              title: err.data.status,
              icon: "error",
              confirmButtonText: "Ok!",
            });
          }
          this.getAllContent();
        }
      });
    },
    openModal(id) {
      this.content = [];
      document.getElementById("editCandidate").showModal();
      this.content = this.contents.filter((cont) => cont.id_content == id);
      this.title = this.content[0].title;
      this.description = this.content[0].description;
      this.titleEn = this.content[0].title_en;
      this.descriptionEn = this.content[0].description_en;
      this.img = this.content[0].img;
    },
  },
  computed: { ...mapGetters(["getContent"]) },
};
</script>
<style scoped>
#content {
  padding: 50px 60px 0px 300px;
}

.card {
  margin: 0 auto; /* Added */
  float: none; /* Added */
  margin-bottom: 10px; /* Added */
  margin-top: 20px;
}
.card-text >>> img {
  max-width: 100%;
}
#no {
  padding: 50px;
}
#arrow {
  text-decoration: none;
  color: black;
}
h2:hover {
  text-decoration: none;
}

.card-body{
  display: flex;
  flex-direction: column;
  //align-items: start;
  justify-content: flex-start;
}
.pt .title , .pt .desc , .en .title , .en .desc {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
